import { Box, Container } from "@mui/material";
import parse from "html-react-parser";
import TransformEditor from "./TransformEditor";

type PreviewCkeditorProps = {
  content: string;
};

const PreviewCkeditor = (props: PreviewCkeditorProps) => {
  return (
    <Container
      sx={{
        // py: (theme) => theme.customLayout.py,
        // px: (theme) => theme.customLayout.px,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box className="ck-content">
        {parse(props.content, { replace: TransformEditor })}
      </Box>
    </Container>
  );
};

export default PreviewCkeditor;
